export const MAX_SPELLINGS_PER_TYPE = 25;
